import type { Rmc } from "../models/rmc.model"; // Adjust the import path as necessary
import { httpService } from "./httpService";
//import type { CreateRMCDto } from '../models/create-rmc.dto'; // Ensure this file exists or update the path accordingly
import { ListItem } from "../models/ListItem"; // Adjust the import path as necessary
import GenericService from "./genericService";

export class RMCService extends GenericService<Rmc, ListItem> {
  private apiPath: string;

  constructor() {
    super("/api/rmc");
    this.apiPath = "/api/rmc";
  }

  async bulkImport(formData: FormData): Promise<any> {
    try {
      const response = await httpService.post(
        `${this.apiPath}/BulkImport`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export const rmcService = new RMCService();
